namespace GeniuzPOS.LogManage {
    export interface LogJsonRow {
        Id?: number;
        LogType?: string;
        LogMessage?: string;
        LogData?: string;
        ApiPath?: string;
        CreatedBy?: string;
        CreatedDate?: string;
    }

    export namespace LogJsonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'LogType';
        export const localTextPrefix = 'LogManage.LogJson';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            LogType = "LogType",
            LogMessage = "LogMessage",
            LogData = "LogData",
            ApiPath = "ApiPath",
            CreatedBy = "CreatedBy",
            CreatedDate = "CreatedDate"
        }
    }
}
